export const getNumberRemaingMonthsThisYear = (d: string | Date): number => {
    if (typeof d === "string") {
        const date = new Date(d);
        return 12 - date.getMonth();
    } else {
        return 12 - d.getMonth();
    }
};

export const getFullDateUSStyle = (d: Date): string => {
    return d.toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric"
    });
}

export const getShortDateUSStyle = (
    d: Date,
): string => {
    return d.toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
    });
}